import React from "react";

import { render } from "app/bootstrap";

import LegacyPage from "./LegacyPage";

render(<LegacyPage />);